import { Text } from "react-native";

const Txt = props => {
    const is_bold = props?.style?.fontWeight === 'bold';

    return (
        <Text {...props} style={{fontFamily: is_bold ? 'LF-Bold' : 'Libre-Franklin', ...(props.style || {})}} />
    )
}
export default Txt;